import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Globals } from '../models/globals.model';
import { HttpService } from './http.service';
import { HttpClient } from '@angular/common/http';
import { Refinery } from '../models/refinery.model';

@Injectable({
  providedIn: 'root'
})
export class RefineryService {
  public refineryList$ = new Subject<Refinery[]>();
  public refinerySelected = new Subject<Refinery>();
  public currentRefinery: Refinery;
  apiUri: string;
  graphUri: string;
  constructor(private readonly http: HttpClient, private readonly httpService: HttpService, private readonly globals: Globals,
    ) {
    this.apiUri = this.globals.config.platformAdminApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
  }

  /**
   * calls api for getting list of tenants and exports data to other
   * components using subject 
   */
  getRefineryListFromServer() {
    this.httpService.get(this.apiUri + 'api/Refinery', null).subscribe((data: Refinery[]) => {
      this.refineryList$.next(data);
    }, (err) => {
      console.log(err);
    });
  }
  GetToken() {
    return this.http.get(this.apiUri + 'api/Tenant/GetToken');
  }
  /**
   * @returns tenantlist as an observable
   */
  getRefineries() {
    return this.refineryList$.asObservable();
  }

  /**
   * sets current refinery
   * @param refinery current refinery to be set
   */
  setCurrentRefinery(refinery) {
    this.currentRefinery = refinery;
  }

  /**
   * @returns current refinery
   */
  getCurrentRefinery() {
    return this.currentRefinery;
  }
}
